import { BaseModel } from '../../_base/crud';

export class PharmacyGroup extends BaseModel {
  id: number;
  name: string;
  phone: string;
  fax: string;
  email: string;
  city: string;
  state: string;
  zip: string;
  location_id: number;
  address_1: string;
  address_2: string;
  note: string;
  is_active: boolean;
  preferred_communication_method: 'EMAIL' | 'FAX';
  referral_info: string;
  pharmacy_group_id: string;
  urbanization;

  changeActiveStatus() {
    this.is_active = !this.is_active;
  }
}
